import React, { Component } from "react"
import PropTypes from "prop-types"
import COLOR_PALETTE from "constants/color-palette"
import { Button, ExternalLinkIcon, Hyperlink } from "components"
import { AccordionText } from "AtomicContainers"
import { IdWrapper } from "AtomicComponents"
import { withRadium, DetectCompact, gtmEvent as withGtmEvent } from "higher-order-components"

class VehicleServiceHistory extends Component {
  columns(date, distance, price, dealer, slug) {
    const { compact, printAllLink, gtmOnHistoryButtonClick, gtmEvent } = this.props
    const viewButtonText = "View"
    return (
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div
          style={{
            fontWeight: "600",
            flex: "1 0",
            letterSpacing: ".2em",
            fontSize: "14px"
          }}>
          {date}
        </div>
        {!compact && <div style={{ flex: "1 0" }}>{distance}</div>}
        {!compact && <div style={{ flex: "1 0" }}>{price}</div>}
        {!compact && <div style={{ flex: "1 0" }}>{dealer}</div>}
        {!compact && (
          <div style={{ flex: "0 0 1" }}>
            <Hyperlink
              gtmEvents={[{ func: gtmEvent, args: [gtmOnHistoryButtonClick({ buttonText: viewButtonText })] }]}
              href={printAllLink + "&slug=" + slug}
              external
              style={[styles.link, { color: slug ? COLOR_PALETTE.GRAY_DARK : "transparent" }]}>
              <ExternalLinkIcon
                style={{
                  height: "11px",
                  width: "14px",
                  fill: slug ? COLOR_PALETTE.BLACK : "transparent",
                  marginRight: "0.5em"
                }} />
              <span>{viewButtonText}</span>
            </Hyperlink>
          </div>
        )}
      </div>
    )
  }

  accordionTitle(service) {
    return (
      <IdWrapper key={service.slug} slug={service.slug}>
        <div
          style={{
            color: COLOR_PALETTE.BLACK,
            borderRight: service.completedServiceItems.length
              ? "1px solid " + COLOR_PALETTE.GRAY
              : "0",
            fontWeight: "200",
            padding: "1.2em 2em 1.2em 0",
            marginRight: "1em"
          }}>
          {this.columns(
            service.serviceDates,
            service.distance,
            service.formattedPrice,
            service.dealerName,
            service.slug
          )}
        </div>
      </IdWrapper>
    )
  }

  render() {
    const {
      compact, emptyHistoryText, serviceHistoryData, printAllLink, gtmOnHistoryButtonClick, gtmEvent
    } = this.props

    const printButtonText = "Print view"

    return (
      <div style={{ padding: "5em 0 0" }}>
        <div style={{ padding: "0 4em 1em 0", marginRight: "1em" }}>
          {!compact && (
            <div style={styles.label}>
              {this.columns("DATE", "ODOMETER (KM)", "PRICE", "SERVICE LOCATION", null)}
            </div>
          )}
        </div>
        <div style={{ borderBottom: "1px solid " + COLOR_PALETTE.GRAY }}>
          {serviceHistoryData ? (
            serviceHistoryData.map((service, index) => (
              <AccordionText
                key={index}
                title={this.accordionTitle(service)}
                styles={{ padding: "1.5em 2em 1.5em 0" }}
                name={service.slug}
                barBorder="top"
                disabled={!service.completedServiceItems.length}
                ignorePropsComponents>
                {service.completedServiceItems && service.completedServiceItems.length ? (
                  <div style={{ padding: "2em 0" }}>
                    {compact && (
                      <div>
                        <div style={{ fontWeight: "200", marginBottom: "1em" }}>
                          <div style={styles.label}>ODOMETER (KM)</div>
                          {service.distance}
                        </div>
                        <div style={{ fontWeight: "200", marginBottom: "1em" }}>
                          <div style={styles.label}>PRICE</div>
                          {service.formattedPrice}
                        </div>
                        <div style={{ fontWeight: "200", marginBottom: "1em" }}>
                          <div style={styles.label}>SERVICE LOCATION</div>
                          {service.dealerName}
                        </div>
                      </div>
                    )}
                    <p style={styles.label}>SERVICE DESCRIPTION</p>
                    {service.completedServiceItems.map((item, i) => {
                      return (
                        <p key={i} style={{ fontWeight: "200" }}>
                          {item.serviceDescription}
                        </p>
                      )
                    })}
                  </div>
                ) : null}
              </AccordionText>
            ))
          ) : (
            <p
              style={{
                borderTop: "1px solid " + COLOR_PALETTE.GRAY,
                padding: "2em 0",
                margin: "0",
                textAlign: "center"
              }}>
              {emptyHistoryText ||
                "We'll automatically keep your service records here when you complete a Mazda Genuine Service."}
            </p>
          )}
        </div>
        {serviceHistoryData && (
          <div style={{ padding: "3em 0 0", textAlign: "center" }}>
            <Button
              styleName="blackOutlined"
              type="a"
              gtmEvents={[{ func: gtmEvent, args: [gtmOnHistoryButtonClick({ buttonText: printButtonText })] }]}
              href={printAllLink}
              display="inline"
              alignment="center"
              external >
              {printButtonText}
            </Button>
          </div>
        )}
      </div>
    )
  }
}

const styles = {
  label: {
    color: COLOR_PALETTE.GRAY_DARK,
    textTransform: "uppercase",
    fontSize: "81%",
    margin: "0 0 1em",
    display: "block",
    fontWeight: "600",
    letterSpacing: ".2em"
  },
  link: {
    fontSize: "13px",
    fontWeight: "200",
    textDecoration: "none",
    letterSpacing: "initial",
    textTransform: "none"
  }
}

VehicleServiceHistory.propTypes = {
  compact: PropTypes.bool,
  emptyHistoryText: PropTypes.string,
  serviceHistoryData: PropTypes.array,
  printAllLink: PropTypes.string,
  gtmEvent: PropTypes.func,
  gtmOnHistoryButtonClick: PropTypes.func
}

export default withRadium(DetectCompact(), withGtmEvent())(VehicleServiceHistory)



// WEBPACK FOOTER //
// ./src/components/mymazda/service/history.jsx